// @flow
import moment from 'moment';
import React, {Component} from 'react';
import classNames from 'classnames';
import {Default, Desktop, Mobile} from '../../../../utils/responsive';

import style from './BlackWeekendBanner.scss';
import blackWeekendLogoWeb from '../../../../assets/img/home/black-weekend/logo-web.png';
import blackWeekendLogoMobile from '../../../../assets/img/home/black-weekend/logo-mobile.png';

type State = {
  remainingTime: number;
  timeUp: boolean;
};

export default class BlackWeekendBanner extends Component<{ }, State> {
  interval: IntervalID;

  constructor(props: Props) {
    super(props);
    const expiresAt = (new Date(2020, 10, 30)).getTime();
    const n = Date.now();
    const remainingTime = typeof expiresAt === 'number' && expiresAt > n ? expiresAt - n : 0;
    const timeUp = remainingTime <= 0;
    this.state = {
      remainingTime,
      timeUp,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() =>
      this.setState((state: State) => {
        if (!state.timeUp) {
          let timeUp = false;
          if (state.remainingTime < 0 && !state.timeUp) {
            timeUp = true;
            // Handle time up logic
          }
          return ({
            remainingTime: state.remainingTime - 1000,
            timeUp,
          })
        } else {
          return state;
        }
      }), 1000);
  }

  componentWillUnmount() {
    if (typeof this.interval === 'number') {
      clearInterval(this.interval);
    }
  }
  
  buildTime = () => {
    const { timeUp, remainingTime } = this.state;
    if (!timeUp) {
      const tempTime = moment.duration(remainingTime);
      const days = tempTime.days() < 10 ? `0${tempTime.days()}` : tempTime.days();
      const hours = tempTime.hours() < 10 ? `0${tempTime.hours()}` : tempTime.hours();
      const minutes = tempTime.minutes() < 10 ? `0${tempTime.minutes()}` : tempTime.minutes();
      const seconds = tempTime.seconds() < 10 ? `0${tempTime.seconds()}` : tempTime.seconds();
      return {
        days,
        hours,
        minutes,
        seconds,
      };
    }
    return {};
  }
  
  render() {
    const { days, hours, minutes, seconds } = this.buildTime();
    const { timeUp } = this.state;
    return !timeUp && (
      <div className={style.blackWeekend}>
        <div className={style.content}>
          <Mobile>
            <img src={blackWeekendLogoMobile} alt="black-weekend"/>
          </Mobile>
          <Default>
            <img src={blackWeekendLogoWeb} alt="black-weekend"/>
          </Default>
          <Desktop>
            <span className={style.text}>¡Envío nacional GRATIS en todos tus pedidos! Termina en:</span>
          </Desktop>
          <div className={style.timeWrap}>
            <Mobile>
              <span className={style.text}> ¡Envío nacional GRATIS! Fin:</span>
            </Mobile>
            {/*<div className={style.unitWrap}>
              <p className={style.number}>{days}</p>
              <span>días</span>
            </div>*/}
            <div className={style.unitWrap}>
              <p className={style.number}>{hours}</p>
              <span>hor</span>
            </div>
            <div className={style.unitWrap}>
              <p className={style.number}>{minutes}</p>
              <span>min</span>
            </div>
            <div className={classNames(style.unitWrap, style.fromMobile)}>
              <p className={style.number}>{seconds}</p>
              <span>seg</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/modules/home/components/BlackWeekendBanner/BlackWeekendBanner.jsx